import { FC, ReactNode } from 'react';

import { Article } from '../../../types/Article';
import { BreadcrumbProps } from '../../../types/Breadcrumb';
import { LayoutTwoColumn } from '../../Layout/LayoutTwoColumn';
import { Loading } from '../../Loading';

import type { AuthorizationRequest } from '../../../types';
import type { LoggedInUser } from '../../../types/LoggedInUser';
import type { PageHeader } from '../../../types/PageHeader';
import type { AppEnv } from '@/packages/nurse-senka-frontend-sdk';

export type AccountTwoColumnTemplateProps = {
  pageHeader: PageHeader;
  appEnv: AppEnv;
  breadcrumbElements: BreadcrumbProps[];
  loggedInUser: LoggedInUser;
  children?: ReactNode;
  loading: boolean;
  authorizationRequest?: AuthorizationRequest;
  knowledgeRankingArticles?: Article[];
  squareRankingArticles?: Article[];
};

export const AccountTwoColumnTemplate: FC<AccountTwoColumnTemplateProps> = ({
  pageHeader,
  appEnv,
  breadcrumbElements,
  loggedInUser,
  children,
  loading,
  authorizationRequest,
  knowledgeRankingArticles,
  squareRankingArticles,
}) => (
  <>
    <LayoutTwoColumn
      pageHeader={pageHeader}
      sideMenuType="default"
      appEnv={appEnv}
      isLoggedIn={true}
      breadcrumbElements={breadcrumbElements}
      loggedInUser={loggedInUser}
      authorizationRequest={authorizationRequest}
      knowledgeRankingArticles={knowledgeRankingArticles}
      squareRankingArticles={squareRankingArticles}
    >
      {children}
    </LayoutTwoColumn>
    <Loading loading={loading} />
  </>
);
